import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import "./assets/responsive.css";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Praductdetail from "./Pages/Praductdetail";
import Category from "./Pages/Category";
import ShoppingCart from "./Pages/ShoppingCart";
import BillingAddress from "./Pages/BillingAddress";
import BillingAddressform from "./Components/BillingAddresspage/BillingAddressform";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ScrollToTop from "react-scroll-to-top";
import LoginPage from "./Components/Loginpage/LoginPage";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import Register from "./Components/RegisterScreen/Register";
import Myprofile from "./Pages/Myprofile";
import Wishlistpage from "./Pages/Wishlistpage";
import BillingEditadd from "./Pages/BillingEditadd";
import Myprofileedit from "./Components/Myprofileupdate/Myprofileedit";
import ProfileUpdate from "./Components/ProfileUpdate/ProfileUpdate";
import Coupouns from "./Components/Coupons/Coupouns";
import PaymentSuceess from "./Components/paymentsuccess/PaymentSuceess";
import Orders from "./Components/Orders/Orders";
import OrderTrack from "./Components/TrackOrderpage/TrackOrder"
import OrderDetail from "./Components/TrackOrderpage/TrackOrder";
import ShippingReturns from "./Components/ShippingReturns/ShippingReturns";
import SubCategory from "./Components/SubCategory/SubCategory";
import SubCategoryDetail from "./Components/SubCategory/SubCategoryDetail";
import PrivacyPolicy from "./Components/Policy/PrivacyPolicy";
import ShippingPolicy from "./Components/Policy/ShoppingPolicy";
import TermsConditions from "./Components/Policy/TermsConditions";
import RefundPolicy from "./Components/Policy/RefundPolicy";
import Contactus from "./Components/Policy/Contact";
import AboutUs from "./Components/Policy/AboutUs";
import WhatsAppButton from "./Components/WhatsAppButton";
import Buynow from "./Components/BuyNow/Buynow";


function App() {
  return (

    <BrowserRouter basename="/">
      <ScrollToTop smooth component={<FontAwesomeIcon icon={faAngleUp} />} className="scroll icon" />
      <Routes>
        <Route path="/" element={<><Home /><Footer /></>} />

        <Route path="/product-detail/:product_id" element={<div className="header-color"><Praductdetail /><Footer /></div>} />
        <Route path="/shoping-cart" element={<div className="header-color"><ShoppingCart /><Footer /></div>} />
        <Route path="/Billing-Address" element={<div className="header-color"><Header /><BillingAddress /><Footer /></div>} />
        <Route path="/Billing-Address-Form" element={<div className="header-color"><Header /><BillingAddressform /><Footer /></div>} />
        <Route path="/Login-Page" element={<div className="header-color"><Header /><LoginPage /><Footer /></div>} />
        <Route path="/Register-Page" element={<div className="header-color"><Header /><Register /><Footer /></div>} />
        <Route path="/myprofile" element={<div className="header-color"><Header /><Myprofile /><Footer /></div>} />
        <Route path="/wishlist" element={<div className="header-color"><Wishlistpage /><Footer /></div>} />
        <Route path="/Billingedit/:addresid" element={<div className="header-color"><Header /><BillingEditadd /><Footer /></div>} />
        <Route path="/Myprofileedit/:addresid" element={<div className="header-color"><Header /><Myprofileedit /><Footer /></div>} />
        <Route path="/Profileupdate" element={<div className="header-color"><Header /><ProfileUpdate /><Footer /></div>} />
        <Route path="/Coupouns" element={<div className="header-color"><Header /><Coupouns /><Footer /></div>} />
        <Route path="/Order-success" element={<div className="header-color"><Header /><PaymentSuceess /><Footer /></div>} />
        <Route path="/Orders" element={<div className="header-color"><Header /><Orders /><Footer /></div>} />
        <Route path="/order-detail/:order_id" element={<div className="header-color"><Header /> <OrderDetail /><Footer /></div>} />
        <Route path="/shipping-returns" element={<div className="header-color"><Header /><ShippingReturns /><Footer /></div>} />
        <Route path="/privacy-policy" element={<div className="header-color"><Header /><PrivacyPolicy /><Footer /></div>} />
        <Route path="/shipping-policy" element={<div className="header-color"><Header /><ShippingPolicy /><Footer /></div>} />
        <Route path="/terms-conditions" element={<div className="header-color"><Header /><TermsConditions /><Footer /></div>} />
        <Route path="/refund-policy" element={<div className="header-color"><Header /><RefundPolicy /><Footer /></div>} />
        <Route path="/contact" element={<div className="header-color"><Header /><Contactus /><Footer /></div>} />
        <Route path="/about" element={<div className="header-color"><Header /><AboutUs /><Footer /></div>} />
        <Route
          path="/subcategory/:category_id"
          element={
            <div className="header-color">
              <Header />
              <SubCategory /> {/* show list of subcategories */}
              <Footer />
            </div>
          }
        />

        <Route
          path="/category-page/:id" // id can be category_id or subcategory_id
          element={
            <div className="header-color">
              <Category /> {/* show products based on id */}
              <Footer />
            </div>
          }
        />


        <Route
          path="/subcategory-detail/:subcategory_id"
          element={
            <div className="header-color">
              <Header />
              <SubCategoryDetail />
              <Footer />
            </div>
          }
        />

        <Route
         path="/Buynow/:id"
          element={
            <div className="header-color">
              <Header />
              <Buynow />
             
              <Footer />
            </div>
          }
        />




      </Routes>
      <WhatsAppButton />
    </BrowserRouter>
  );
}

export default App;
